import { Component, input } from '@angular/core';
import { IColumn } from '@app/shared/interfaces/column.interface';
import { IFiltredDashboardResponse } from '@app/shared/interfaces/dashboard.interface';
import { TableComponent } from '@app/shared/components/table-component/table.component';
import { ExcelButtonComponent } from '@app/shared/components/excel-button/excel-button.component';
import { CardComponent } from '@app/shared/components/card/card.component';

@Component({
    selector: 'app-airline-statistics',
    imports: [TableComponent, ExcelButtonComponent, CardComponent],
    templateUrl: './airline-statistics.component.html',
    styleUrl: './airline-statistics.component.scss'
})
export class AirlineStatisticsComponent {
    loading = input<boolean>(false);
    airlineStatisticsData = input<IFiltredDashboardResponse['airlineStatistic']['results']>();

    cols: IColumn[] = [
        { key: 'airlineCode', label: 'Airline Code' },
        { key: 'provider', label: 'Provider' },
        { key: 'supplier', label: 'Supplier' },
        { key: 'pax', label: 'Pax' },
        { key: 'lastYearPax', label: "Last Year's Pax" }
    ];

    exportData(): any[] {
        return (
            this.airlineStatisticsData()?.map((item) => ({
                airlineCode: item.airlineCode ?? '',
                provider: item.provider ?? '',
                supplier: item.supplier ?? '',
                pax: item.pax ?? '',
                lastYearPax: item.lastYearPax ?? ''
            })) ?? []
        );
    }
}
